module.exports = __webpack_public_path__ + "d308073b/img/rename-icon.de4e673d.svg";